var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.indent)},[_vm._v(_vm._s(_vm.label))]),_vm._l((_vm.children),function(child){return _c('hierarchy-tree',{key:child.dbId,attrs:{"children":child.children,"label":child.name,"depth":_vm.depth + 1}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }